export interface Product {
  id: string
  name: string
  ref: string
  subtitle: string
  subtitleEn: string
  price: number
  originalPrice?: number
  priceLabel: string
  priceLabelEn: string
  image: string
  stock: number
  description: string
  descriptionEn: string
  category: string
  sizes: string[]
  launchOffer?: boolean
  soldOut?: boolean
}

export const products: Product[] = [
  {
    id: "btn-white-pearl",
    name: "White",
    ref: "B1000",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 4.0,
    originalPrice: 5.0,
    priceLabel: "4,00 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC4.00 per pouch of 5",
    image: "https://static.lumi.new/28/2841a88868d88414c6d9bd6787652d27.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"],
    launchOffer: true
  },
  {
    id: "btn-black",
    name: "Black",
    ref: "B1011",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/ed/edc9fd9c24887fbb6c38a57e0de37da7.webp",
    stock: 0,
    description: "Regular \u2014 Nylon 6/6, 18 mm ou 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm or 20 mm",
    category: "REGULAR",
    sizes: ["18 mm", "20 mm"],
    soldOut: true
  },
  {
    id: "btn-red",
    name: "Red",
    ref: "B1022",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/e1/e163d8ab4dcb630669b059c86c8cca9d.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"]
  },
  {
    id: "btn-kelly-green",
    name: "Kelly Green",
    ref: "B1044",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 4.95,
    originalPrice: 5.5,
    priceLabel: "4,95 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC4.95 per pouch of 5",
    image: "https://static.lumi.new/bb/bbbc02859a58cbdbc773022de9b537c5.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 18 mm ou 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm or 20 mm",
    category: "REGULAR",
    sizes: ["18 mm", "20 mm"],
    launchOffer: true
  },
  {
    id: "btn-yellow",
    name: "Yellow",
    ref: "B1055",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 4.95,
    originalPrice: 5.5,
    priceLabel: "4,95 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC4.95 per pouch of 5",
    image: "https://static.lumi.new/8c/8cf1c4f18bc1ee7f315fc9f7c6ca9e77.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"],
    launchOffer: true
  },
  {
    id: "btn-choc-brown",
    name: "Choc. Brown",
    ref: "B1077",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"]
  },
  {
    id: "btn-baby-pink",
    name: "Baby Pink",
    ref: "B1099",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/86/866f0dd93c59bd3e4514fa4742a981c1.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"]
  },
  {
    id: "btn-bugatti-blue",
    name: "Bugatti Blue",
    ref: "B1133",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/f8/f8707feaf90299b5112af6889c93a872.webp",
    stock: 0,
    description: "Regular \u2014 Nylon 6/6, 18 mm ou 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm or 20 mm",
    category: "REGULAR",
    sizes: ["18 mm", "20 mm"],
    soldOut: true
  },
  {
    id: "btn-dark-brown",
    name: "Dark Brown",
    ref: "B1177",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/2a/2a91f0a2af94645b3d99b54635ddcc68.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 18 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm",
    category: "REGULAR",
    sizes: ["18 mm"]
  },
  {
    id: "btn-dark-purple",
    name: "Dark Purple",
    ref: "B1188",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/31/3183a5b565c406cc4e4e5a2d4a8c2a55.webp",
    stock: 0,
    description: "Regular \u2014 Nylon 6/6, 18 mm ou 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm or 20 mm",
    category: "REGULAR",
    sizes: ["18 mm", "20 mm"],
    soldOut: true
  },
  {
    id: "btn-dark-grey",
    name: "Dark Grey",
    ref: "B1211",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 18 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm",
    category: "REGULAR",
    sizes: ["18 mm"]
  },
  {
    id: "btn-royal-blue",
    name: "Royal Blue",
    ref: "B1233",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/7d/7d687eb1b95faca3ccc0f89cf5a95a06.webp",
    stock: 0,
    description: "Regular \u2014 Nylon 6/6, 18 mm ou 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm or 20 mm",
    category: "REGULAR",
    sizes: ["18 mm", "20 mm"],
    soldOut: true
  },
  {
    id: "btn-hunter-green",
    name: "Hunter Green",
    ref: "B1244",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 4.95,
    originalPrice: 5.5,
    priceLabel: "4,95 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC4.95 per pouch of 5",
    image: "https://static.lumi.new/5e/5edfcfa3e033e95e78efb463fcacdad6.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"],
    launchOffer: true
  },
  {
    id: "btn-raspberry",
    name: "Raspberry",
    ref: "B1299",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/fd/fda3cc5e55c497bca753bca6e7fed955.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"]
  },
  {
    id: "btn-baby-blue",
    name: "Baby Blue",
    ref: "B1333",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/89/89dcd64260fbac0ba9f561bb32aca581.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"]
  },
  {
    id: "btn-seafoam",
    name: "Seafoam",
    ref: "B1344",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 4.95,
    originalPrice: 5.5,
    priceLabel: "4,95 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC4.95 per pouch of 5",
    image: "",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 20 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 20 mm",
    category: "REGULAR",
    sizes: ["20 mm"],
    launchOffer: true
  },
  {
    id: "btn-safari-beige",
    name: "Safari Beige",
    ref: "B1377",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 18 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm",
    category: "REGULAR",
    sizes: ["18 mm"]
  },
  {
    id: "btn-navy-blue",
    name: "Navy Blue",
    ref: "B1433",
    subtitle: "Regular",
    subtitleEn: "Regular",
    price: 5.5,
    priceLabel: "5,50 \u20AC la pochette de 5",
    priceLabelEn: "\u20AC5.50 per pouch of 5",
    image: "https://static.lumi.new/c8/c89e27f29c4ff3a711eb5f2daf97abda.webp",
    stock: 99,
    description: "Regular \u2014 Nylon 6/6, 18 mm",
    descriptionEn: "Regular \u2014 Nylon 6/6, 18 mm",
    category: "REGULAR",
    sizes: ["18 mm"]
  }
]
